exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".csv-table {\n  width: 100%;\n  overflow-x: auto; }\n\n.create-table {\n  width: 100%; }\n\ncaption {\n  font-size: 12px;\n  color: #035168;\n  font-weight: 800; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src1233824947/src/src/app/generic-ui-components/allocable-cost-table/allocable-cost-table.component.scss
// module id = ../../../../../src/app/generic-ui-components/allocable-cost-table/allocable-cost-table.component.scss
// module chunks = main